import Canvas from "@/components/canvas.js";

window.addEventListener("load", () => {
  new Canvas();
});
